<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 513.32 513.32"
    style="enable-background: new 0 0 513.32 513.32"
    xml:space="preserve"
    :fill="fill"
  >
    <path
      d="M256.66,0C168.968,0,89.831,44.916,42.777,115.497V21.388H0v171.107h171.107v-42.777H72.72
			C111.219,83.414,179.662,42.777,256.66,42.777c117.636,0,213.883,96.247,213.883,213.883S374.296,470.543,256.66,470.543
			c-102.664,0-192.495-72.72-209.605-175.385c-2.139-10.694-12.833-19.249-25.666-17.11c-10.694,2.139-19.249,12.833-17.11,25.666
			C25.666,425.628,132.608,513.32,256.66,513.32c141.163,0,256.66-115.497,256.66-256.66S397.823,0,256.66,0z"
    />
  </svg>
</template>
<script>
export default {
  name: 'CircledArrowIcon',
  props: {
    fill: {
      type: String,
      default: '#ffffff',
    },
  },
};
</script>
